import { withInstall, withNoopInstall } from '@bigin/utils'

import Dropdown from './src/dropdown.vue'
import DropdownItem from './src/dropdown-item.vue'
import DropdownMenu from './src/dropdown-menu.vue'

export const BDropdown = withInstall(Dropdown, {
  DropdownItem,
  DropdownMenu,
})
export default BDropdown
export const BDropdownItem = withNoopInstall(DropdownItem)
export const BDropdownMenu = withNoopInstall(DropdownMenu)
export * from './src/dropdown'
export * from './src/tokens'
